namespace TotalContest {
    import Component = TotalCore.Common.Component;

    @Component('components.totalcontest', {
        templateUrl: 'welcome-component-template',
        bindings: {}
    })
    class WelcomeComponent {
        public constructor(private $scope) {

        }
    }
}
